import { HttpEvent, HttpHandler, HttpInterceptor, HttpInterceptorFn, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { AuthenticationService } from "@sgprev-services";
import { Injectable } from "@angular/core";
import { environment } from 'environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private authService: AuthenticationService) {}
    
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const api = new URL(environment.API_URL || '/', window.location.origin);
        const url = new URL(req.url, window.location.origin);
        const path = api.pathname.replace(/\/$/, '');
        if (url.origin !== api.origin || (path && url.pathname !== path && !url.pathname.startsWith(path + '/'))) return next.handle(req);
        let headers = req.headers;
        if (this.authService.token) headers = headers.set('Authorization', `Bearer ${this.authService.token}`);
        if (this.authService.identity) headers = headers.set('X-SGPREV-Identity', this.authService.identity);
        // Guardião do iframe (modelo anterior a 21/09): a API identifica o operador por ele quando o
        // legado não emite a identidade assinada. Base64url para o header aceitar acentos.
        const guardiao = encodeGuardiao(this.authService.guardiao);
        if (guardiao) headers = headers.set('X-SGPREV-Guardiao', guardiao);
        return next.handle(req.clone({ headers }));
    }
}

export function encodeGuardiao(guardiao: unknown): string | null {
    if (!guardiao || typeof guardiao !== 'object') return null;
    try {
        const bytes = new TextEncoder().encode(JSON.stringify(guardiao));
        let binary = '';
        bytes.forEach(b => binary += String.fromCharCode(b));
        return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    } catch {
        return null;
    }
}
